import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveTextComponent from './js/live-text.component';
import LiveTextListing from './js/live-text-listing';

ComponentsFactory.getInstance().define('live-text', LiveTextComponent);

export {
    LiveTextListing
};
